import {
    stringify as qsify,
} from 'query-string';

import {
    WapiService,
} from 'wanderu-service-wapi';
import {
    removeDiacritics,
} from 'wanderu-utils';

export async function getCarrierContact(requestParams) {
    const qs = {
        locale: requestParams.locale,
    };

    return WapiService.get(`carriercontact.json?${qsify(qs)}`);
}

export async function getCarrierGuide(requestParams) {
    const qs = {
        carrier_guide_id: requestParams.carrierGuideId,
        locale: requestParams.locale,
    };

    return WapiService.get(`carrierguides.json?${qsify(qs)}`);
}

export async function getCityGuide(requestParams) {
    const qs = {
        locale: requestParams.locale,
        region: requestParams.region,
        city: removeDiacritics(requestParams.city),
        trans_mode: requestParams.transMode,
    };

    return WapiService.get(`cityguide.json?${qsify(qs)}`);
}

export async function getCityToCityData(requestParams) {
    const qs = {
        locale: requestParams.locale,
        depart_region: requestParams.departRegion,
        depart_city: removeDiacritics(requestParams.departCity),
        arrive_region: requestParams.arriveRegion,
        arrive_city: removeDiacritics(requestParams.arriveCity),
        trans_mode: requestParams.transMode,
    };

    return WapiService.get(`c2c.json?${qsify(qs)}`);
}

export async function getCountryGuideContent(requestParams) {
    const qs = {
        locale: requestParams.locale,
        country: requestParams.country,
        trans_mode: requestParams.transMode,
    };

    return WapiService.get(`countryguide.json?${qsify(qs)}`);
}

export async function getIndexGuideContent(requestParams) {
    const qs = {
        locale: requestParams.locale,
        trans_mode: requestParams.transMode,
    };

    return WapiService.get(`indexguide.json?${qsify(qs)}`);
}

export function getNewRoutes(locale) {
    const qs = { locale };
    return WapiService.get(`links/engagementc2c.json?${qsify(qs)}`);
}

export async function getReviewFeedContent(reviewId, locale, reviewType) {
    const query = {
        locale,
        review_id: reviewId,
        count: 5,
        review_type: reviewType,
    };

    return WapiService.post('reviewfeed.json', {
        body: query,
    });
}

export async function getScheduleData(requestParams) {
    const qs = {
        depart_wcityid: requestParams.departCity,
        arrive_wcityid: requestParams.arriveCity,
        transportation_mode: requestParams.transMode,
    };

    const res = WapiService.get(`schedules.json?${qsify(qs)}`);
    return res;
}

export async function getStateGuideContent(requestParams) {
    const qs = {
        locale: requestParams.locale,
        country: requestParams.country,
        state: requestParams.state,
        trans_mode: requestParams.transMode,
    };

    return WapiService.get(`stateguide.json?${qsify(qs)}`);
}

export default {
    getCarrierContact,
    getCityToCityData,
    getCarrierGuide,
    getCityGuide,
    getStateGuideContent,
    getCountryGuideContent,
    getNewRoutes,
    getScheduleData,
};
